import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { NavState } from './nav.state';
import { getters } from './nav.getters';
import { mutations } from './nav.mutations';
import { actions } from './nav.actions';

VueXHelper.setStoreModule(Module.NAV, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new NavState(),
  getters,
  mutations,
  actions,
};
